import FormulesController from './formules.controller';

export default {
    template: require('./formules.tpl.html'),
    controller: FormulesController
};
